import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiserviceService {

  private apiUrl = 'https://jsonplaceholder.typicode.com/users'; // fake API

  private apiUrlsub = 'https://jsonplaceholder.typicode.com/users'; // fake API

  private apiUrlbudgethead = 'https://jsonplaceholder.typicode.com/users'; // fake API

  private apiUrlgrade = 'https://jsonplaceholder.typicode.com/users'; // fake API

  private apiUrlrole = 'https://jsonplaceholder.typicode.com/users';

  private apiUrlHonurium = 'https://jsonplaceholder.typicode.com/users';

  private apisavetraining = 'https://jsonplaceholder.typicode.com/users';

  private apiUrlgetroledata = '/assets/jsondata/role.json';

  private apiUrlgetcategoriesdata = '/assets/jsondata/categories.json';
  
  private apisavecmtc = 'https://jsonplaceholder.typicode.com/users';

   private apisavetrainee = 'https://jsonplaceholder.typicode.com/users';

  constructor(private http: HttpClient) {}


  // POST request to save category
  /*
    {
      "success": true,
      "message": "Category stored successfully!"
    }
  */
  saveCategory(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  savesubCategory(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrlsub, data);
  }

  savebudgetHead(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrlbudgethead, data);
  }

  saveGrades(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrlgrade, data);
  }

  saveRole(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrlrole, data);
  }

  getRoles(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrlgetroledata);
  }

  saveHonurium(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrlHonurium, data);
  }


  saveTraining(data: FormData): Observable<any> {
    return this.http.post<any>(this.apisavetraining, data);
  }
  saveTrainee(data: any): Observable<any> {
    return this.http.post<any>(this.apisavetrainee, data);
  }
  getcategories(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrlgetcategoriesdata);
  }

  saveCmtc(data: any): Observable<any> {
    return this.http.post<any>(this.apisavecmtc, data);
  }
} 
